import { render, staticRenderFns } from "./vpd-modify-calculation.vue?vue&type=template&id=4c846f34"
import script from "./vpd-modify-calculation.vue?vue&type=script&lang=js"
export * from "./vpd-modify-calculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports